import { useCallback, useState } from 'react';

import { initialErrorState } from 'features/payment/initial-state';
import { isGiftCardNumberValid } from 'features/payment/utils';

import { t } from 'state/intl/translations';
import { sanitizeNumber } from 'utils/form';

const isValidGiftCardNumberCheck = (newGiftCardNumber: string) =>
  isGiftCardNumberValid(sanitizeNumber(newGiftCardNumber));

export const useCardNumber = () => {
  const [giftCardNumber, setGiftCardNumber] = useState('');
  const [errors, setErrors] = useState(initialErrorState);
  const [isValidGiftCardNumber, setIsValidGiftCardNumber] = useState(false);

  const validateCardNumber = useCallback((newGiftCardNumber: any) => {
    const isValid = isValidGiftCardNumberCheck(newGiftCardNumber);
    let giftCardNumberErrorMessage: string | undefined;
    if (!isValid) {
      giftCardNumberErrorMessage = newGiftCardNumber
        ? t('giftCardNumberIsNotValid')
        : t('giftCardNumberIsRequired');
    }
    setErrors(prevState => {
      return {
        ...prevState,
        giftCardNumber: giftCardNumberErrorMessage,
      };
    });
    setIsValidGiftCardNumber(isValid);
  }, []);

  const handleCardNumberChange = useCallback(
    (newGiftCardNumber: any) => {
      const formattedNumber = sanitizeNumber(newGiftCardNumber);
      setGiftCardNumber(formattedNumber);

      validateCardNumber(formattedNumber);
    },
    [validateCardNumber]
  );

  return {
    giftCardNumber,
    errors,
    isValidGiftCardNumber,
    handleCardNumberChange,
    isValidGiftCardNumberCheck,
    validateCardNumber,
  };
};
